// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Page wrapper */
.Support_page__1QASh {
  min-height: 100vh;
  padding-top: 80px; /* ✅ space for fixed navbar */
  display: flex;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Main container */
.Support_container__CehRp {
  width: 100%;
  max-width: 720px;
  padding: 48px 20px 80px;
}

/* Header */
.Support_header__cyeG2 {
  text-align: start;
  margin: 0;
}

.Support_title__jyhN5 {
  font-size: 24px;
  color: rgba(31, 41, 55, 1);
  font-weight: 300;
  margin-bottom: 15px;
}
.Support_hr__f07xm {
  border: none;
  background-color: rgba(229, 231, 235, 1);
  height: 1px;
  margin-bottom: 20px;
  margin-top: 20px;
}
.Support_subtitle__P1htR {
  font-size: 14px;
  color: #5f6368;
  margin-bottom: 0;
}

/* Card */
.Support_card__Locmq {
  background: #ffffff;
  border-radius: 16px;
  padding: 32px;
  border: 1px solid #e0e0e0;
}

/* Form */
.Support_form__WsPWs {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.Support_field__fP3o5 {
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.Support_field__fP3o5 label {
  font-size: 14px;
  font-weight: 500;
  color: #2b2b2b;
}

/* Inputs */
.Support_field__fP3o5 input,
.Support_field__fP3o5 textarea {
  width: 100%;
  padding: 12px 14px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 14px;
  outline: none;
  transition: border 0.2s ease, box-shadow 0.2s ease;
  font-family: inherit;
}

.Support_field__fP3o5 input::placeholder,
.Support_field__fP3o5 textarea::placeholder {
  color: #9aa0a6;
}

.Support_field__fP3o5 input:focus,
.Support_field__fP3o5 textarea:focus {
  border-color: #644ee5;
  box-shadow: 0 0 0 2px rgba(100, 78, 229, 0.15);
}

/* Submit button */
.Support_submitBtn__QEA1Y {
  margin-top: 12px;

  background: var(--Violet, #644ee5); /* gold tone from screenshot */
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
  padding: 14px;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.Support_submitBtn__QEA1Y:hover {
  background-color: #4e38b3;
  transform: translateY(-2px);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
}
`, "",{"version":3,"sources":["webpack://./src/views/pages/Support.module.css"],"names":[],"mappings":"AAAA,iBAAiB;AACjB;EACE,iBAAiB;EACjB,iBAAiB,EAAE,6BAA6B;EAChD,aAAa;;EAEb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA,WAAW;AACX;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,wCAAwC;EACxC,WAAW;EACX,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,WAAW;AACX;;EAEE,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,aAAa;EACb,kDAAkD;EAClD,oBAAoB;AACtB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;;EAEhB,kCAAkC,EAAE,8BAA8B;EAClE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,iFAAiF;AACnF","sourcesContent":["/* Page wrapper */\n.page {\n  min-height: 100vh;\n  padding-top: 80px; /* ✅ space for fixed navbar */\n  display: flex;\n\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Main container */\n.container {\n  width: 100%;\n  max-width: 720px;\n  padding: 48px 20px 80px;\n}\n\n/* Header */\n.header {\n  text-align: start;\n  margin: 0;\n}\n\n.title {\n  font-size: 24px;\n  color: rgba(31, 41, 55, 1);\n  font-weight: 300;\n  margin-bottom: 15px;\n}\n.hr {\n  border: none;\n  background-color: rgba(229, 231, 235, 1);\n  height: 1px;\n  margin-bottom: 20px;\n  margin-top: 20px;\n}\n.subtitle {\n  font-size: 14px;\n  color: #5f6368;\n  margin-bottom: 0;\n}\n\n/* Card */\n.card {\n  background: #ffffff;\n  border-radius: 16px;\n  padding: 32px;\n  border: 1px solid #e0e0e0;\n}\n\n/* Form */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n}\n\n.field label {\n  font-size: 14px;\n  font-weight: 500;\n  color: #2b2b2b;\n}\n\n/* Inputs */\n.field input,\n.field textarea {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 8px;\n  border: 1px solid #e0e0e0;\n  font-size: 14px;\n  outline: none;\n  transition: border 0.2s ease, box-shadow 0.2s ease;\n  font-family: inherit;\n}\n\n.field input::placeholder,\n.field textarea::placeholder {\n  color: #9aa0a6;\n}\n\n.field input:focus,\n.field textarea:focus {\n  border-color: #644ee5;\n  box-shadow: 0 0 0 2px rgba(100, 78, 229, 0.15);\n}\n\n/* Submit button */\n.submitBtn {\n  margin-top: 12px;\n\n  background: var(--Violet, #644ee5); /* gold tone from screenshot */\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 14px;\n  border: none;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.submitBtn:hover {\n  background-color: #4e38b3;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `Support_page__1QASh`,
	"container": `Support_container__CehRp`,
	"header": `Support_header__cyeG2`,
	"title": `Support_title__jyhN5`,
	"hr": `Support_hr__f07xm`,
	"subtitle": `Support_subtitle__P1htR`,
	"card": `Support_card__Locmq`,
	"form": `Support_form__WsPWs`,
	"field": `Support_field__fP3o5`,
	"submitBtn": `Support_submitBtn__QEA1Y`
};
export default ___CSS_LOADER_EXPORT___;
